import { TFunction } from 'react-i18next';

import {
  Product,
  ProductAttrribute,
} from '../../presentation/features/variety-planner/types';
import { CropConnectLanguages } from '../../services/cropConnectApiClient';

export const generateColumns = (rows: Product[], translate: TFunction) => {
  if (!rows.length) return [];

  const firstRow = rows[0];
  if (!firstRow?.productAttributes) return [];

  // Sort attributes by order
  const sortedAttributes = [...firstRow.productAttributes].sort(
    (a, b) => (a.order as number) - (b.order as number)
  );

  return sortedAttributes.map((attr) => {
    // Create translation key for column header (format: varietyPlanner_Product_CH_0)
    const translationKey = `varietyPlanner_Product_${attr.tag}`;

    return {
      field: attr.tag as string,
      //Forced to DE lng, not edtiable in translation modal as per business requirement on this component
      headerName:
        translate(translationKey, {
          lng: CropConnectLanguages.DeDE,
        }) || (attr.tag as string),
      sortable: true,
    };
  });
};

export const getAttributeValue = (
  tag: string,
  attributes?: ProductAttrribute[]
): string | number | undefined => {
  const attribute = attributes?.find((attr) => attr.tag === tag);
  return attribute?.value;
};
